'use client';

import {usePathname} from '@components/@nav';
import {useMeQuery} from '@hooks';
import {useStableCallback} from '@hooks/useStableCallback';
import {dataLayerEmit} from '@services/gtm/datalayer.service';
import {FC, useEffect} from 'react';

// The 'hotjar_user_attributes' event delays Survicate initialization (SaaS survey tool via GTM) until the user is loaded and user attributes are set.
// If changes made to this event name, make sure to update the survicate initialisation trigger web_app_user_attributes_survey in gtm.
const DataLayerUserAttributes: FC = () => {
    const pathName = usePathname();

    const {
        query: {data: user},
    } = useMeQuery();

    const submitDataLayerHotJarUserAttributes = useStableCallback(() => {
        if (!user) {
            return;
        }

        const userAttributes = {
            user_id: user.id,
            email: user.email,
            subscriptionOrderDate: user.subscription?.aboOrderDate ?? null,
            planID: user.subscription?.itemPriceId ?? null,
            firstName: user.address?.firstName ?? null,
            lastName: user.address?.lastName ?? null,
            userCreatedDate: user.created ?? null,
        };

        dataLayerEmit('hotjar_user_attributes', userAttributes, '');
    });

    useEffect(() => {
        submitDataLayerHotJarUserAttributes();
    }, [pathName, submitDataLayerHotJarUserAttributes]);

    return null;
};

export default DataLayerUserAttributes;
